import type {
  ApiReturnSiteIdsToDashboardIds,
  DashboardInfo,
} from '@highimpact-frontend/api-types';

// -- site dashboard index helpers --

/**
 * Returns all dashboards registered for one site from the bulk map.
 * Returns an empty list when the site has no dashboards.
 */
export const getDashboardsForSite = (
  siteDashboardMap: ApiReturnSiteIdsToDashboardIds,
  siteId: number
): readonly DashboardInfo[] => siteDashboardMap.values[siteId] ?? [];

/**
 * Returns dashboards for one site filtered by dashboard type
 * (for example `user_dashboard` or `report_dashboard`).
 */
export const getDashboardsForSiteByType = (
  siteDashboardMap: ApiReturnSiteIdsToDashboardIds,
  siteId: number,
  dashboardType: string
): readonly DashboardInfo[] =>
  getDashboardsForSite(siteDashboardMap, siteId).filter(
    (dashboard) => dashboard.type === dashboardType
  );

/**
 * Returns dashboards for the standalone home context (site id 0 in the map).
 */
export const getHomepageDashboards = (
  siteDashboardMap: ApiReturnSiteIdsToDashboardIds
): readonly DashboardInfo[] => getDashboardsForSite(siteDashboardMap, 0);

/**
 * Returns homepage dashboards filtered by type.
 */
export const getHomepageDashboardsByType = (
  siteDashboardMap: ApiReturnSiteIdsToDashboardIds,
  dashboardType: string
): readonly DashboardInfo[] =>
  getHomepageDashboards(siteDashboardMap).filter(
    (dashboard) => dashboard.type === dashboardType
  );
